import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Lock from '@material-ui/icons/Lock';
import Visibility from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Form, FormGroup, Card, CardBody } from 'reactstrap';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domain, isTenant, RedirectToApp } from '../../routes/routes'

/* Credentials Token */
import { appToken, setToken } from '../../auth/token';

/* Object Json */
import { isEmpty } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';

/* Logo */
import Logo from '../../lib/components/iconColor/logo.png'
import { titleCaseRemoveUS } from '../../lib/components/formatter';

const WKEY = "APP_LOGIN";
const LOGIN = "LOGIN";
const wBoundActions = buildWBoundActions(WKEY);

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  textField: {
    flexBasis: 200,
  }
});

class AppLogin extends Component {
  constructor(props) {
    super(props);
    let widthForm;
    if (window.innerWidth > 576) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          widthForm = '36%';
        } else {
          widthForm = '52%';
        }
      } else {
        widthForm = '64%';
      }
    } else {
      widthForm = '80%';
    }
    this.state = {
      username: '',
      password: '',
      submitted: false,
      loginSuccess: false,
      showPassword: false,
      loading: false,
      widthForm
    };
    this.resize = this.resize.bind(this);
  }

  resize(event) {
    let widthForm;
    if (window.innerWidth > 576) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          widthForm = '36%';
        } else {
          widthForm = '52%';
        }
      } else {
        widthForm = '64%';
      }
    } else {
      widthForm = '80%';
    }
    this.setState({
      widthForm
    })
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const _domain = domain(_props);
    const _isTenant = isTenant(_props);
    _props.wSetConfig({
      single_config: {
        [LOGIN]: {
          wparam: {
            domain: _domain,
            usingAuth: false,
            method: "POST",
            path: "/service/web/application/account/auth/login"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  const tokenId = safeDeepGet(result, ['body', 'id']);
                  const token = safeDeepGet(result, ['body', 'token']);
                  setToken(_domain, _isTenant, tokenId, token);
                  _props.showSingleNotification({
                    message: 'Selamat datang ' + titleCaseRemoveUS(_state.username),
                    position: 'tr', level: 'info'
                  });
                  _this.setState({ loginSuccess: true });
                  return;
                }
              } else if (result.code === Result.HTTP.BAD_REQUEST) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -1) {
                  _props.showSingleNotification({ message: 'Username tidak terdaftar', position: 'tr', level: 'error' });
                } else if (responseResult === -2) {
                  _props.showSingleNotification({ message: 'Username dan password tidak sesuai', position: 'tr', level: 'error' });
                } else {
                  _props.showSingleNotification({ message: 'Login gagal', position: 'tr', level: 'error' });
                }
              } else if (result.code === Result.NETWORK_FAILURE) {
                _props.showSingleNotification({
                  message: 'Tidak ada koneksi, cek kembali jaringan internet', position: 'tr',
                  level: 'error'
                });
              } else if (result.code === Result.HTTP.INTERNAL_SERVER_ERROR) {
                _props.showSingleNotification({
                  message: 'Server sedang down, silahkan coba lain waktu', position: 'tr',
                  level: 'error'
                });
              } else if (result.code === Result.HTTP.UNAUTHORIZED) {
                _props.history.push('../../admin/login')
                _props.showSingleNotification({
                  message: 'Aplikasi belum terdaftar dalam platform Iotera', position: 'tr',
                  level: 'error'
                });
              } else {
                _props.showSingleNotification({ message: 'Login gagal', position: 'tr', level: 'error' });
              }
              _this.setState({ submitted: false, loading: false });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  componentWillUnmount() {
    this.props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit = event => {
    event.preventDefault();
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    _props.wSingleRequestCall({
      id: LOGIN,
      body: {
        input: _state.username,
        pass: _state.password
      }
    });
    _this.setState({ submitted: true });
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    // Redirect to App
    const _domain = domain(_props);
    const _isTenant = isTenant(_props);
    const token = appToken(_domain, _isTenant);
    if (!isEmpty(token) || _state.loginSuccess) {
      return (
        <RedirectToApp {..._props} />
      );
    }
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let _visibility = 'hidden'
    if (_state.password.length > 0) {
      _visibility = 'visible'
    }
    const { classes } = _props;
    let backgroundUrl = "https://picsum.photos/1920/1080/"
    let logo = Logo;
    if (_domain === 'ioterabridgemonitoring') {
      logo = 'https://live.staticflickr.com/65535/49388984498_a510b5f8b2_o_d.jpg';
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <div className="view-content" style={{ height: '100vh', minHeight: '100vh', padding: 0 }}>
            <div style={{ filter: 'nofilter' }}>
              <div className='centeringItem' style={{ position: 'relative', width: '100%' }}>
                <div style={{
                  display: 'block',
                  minWidth: '100%',
                  height: '100%',
                  minHeight: '100vh',
                  filter: 'blur(8px)',
                  backgroundImage: `url(${backgroundUrl})`,
                  backgroundSize: 'cover',
                  backfaceVisibility: 'hidden'
                }}></div>
                <div className="view-pages view-session" style={{
                  position: 'absolute',
                  top: '5%',
                  minWidth: this.state.widthForm,
                  maxWidth: this.state.widthForm,
                  textAlign: 'center'
                }} >
                  <Card className="mb-3 form-card" style={{ marginTop: '10%', opacity: 0.8 }}>
                    <CardBody style={{ padding: 0 }}>
                      <header className="mb-5" style={{ textAlign: 'center', marginTop: 42 }}>
                        <img src={logo} alt="logo" style={{ height: '80px' }} />
                      </header>
                      <Form onSubmit={_this.handleSubmit} style={{
                        border: '1px solid rgba(255,0,0,.0)', outlineStyle: 'solid',
                        outlineColor: 'transparent'
                      }}>
                        <TextField
                          className={classNames(classes.margin, classes.textField)}
                          variant="outlined"
                          id="input-with-icon-textfield"
                          label="Username"
                          placeholder="username"
                          style={{ minWidth: '95%' }}
                          onChange={_this.handleChange('username')}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccountCircle />
                              </InputAdornment>
                            )
                          }}
                        />
                        <TextField
                          id="outlined-adornment-password"
                          className={classNames(classes.margin, classes.textField)}
                          variant="outlined"
                          type={_state.showPassword ? 'text' : 'password'}
                          label="Password"
                          placeholder="••••••••"
                          style={{ minWidth: '95%' }}
                          onChange={_this.handleChange('password')}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Lock />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="Toggle password visibility"
                                  onClick={_this.handleClickShowPassword}
                                  style={{ outline: 'none', visibility: _visibility }}
                                >
                                  {_state.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <FormGroup style={{ textAlign: 'center', marginTop: 10, marginBottom: 0 }}>
                          <button disabled={_state.submitted} className="button-iotera-primary" 
                          style={{ minWidth: '95%', borderRadius: '41px' }}>Masuk</button>
                        </FormGroup>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Loader>
    )
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

AppLogin.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(null, mapDispatchToProps)(withRouter(withStyles(styles)(AppLogin)));